package com.tregz.robbins

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Button
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import tregz.robbins.generated.resources.Res
import tregz.robbins.generated.resources.ic_branding

enum class Screen {
    Main, Terrence, Jerome
}

@Preview
@Composable
fun App(initialScreen: Screen = Screen.Main) {
    var currentScreen by remember { mutableStateOf(initialScreen) }

    Theme {
        when (currentScreen) {
            Screen.Main -> MainView(onNavigate = { currentScreen = it })
            Screen.Terrence -> Terrence(onBack = { currentScreen = Screen.Main })
            Screen.Jerome -> Jerome(onBack = { currentScreen = Screen.Main })
        }
    }
}

@Composable
fun MainView(onNavigate: (Screen) -> Unit) {
    Column(modifier = Modifier.fillMaxSize(),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center) {

        Spacer(modifier = Modifier.weight(1f))

        Image(
            painter = painterResource(Res.drawable.ic_branding),
            contentDescription = "Logo",
            modifier = Modifier.width(200.dp)
        )
        Spacer(modifier = Modifier.height(8.dp))

        Text("Jerome Robbins",
            textAlign = TextAlign.Center,
            fontWeight = FontWeight.Bold)

        Text("Mobile Developer",
            textAlign = TextAlign.Center)

        Spacer(modifier = Modifier.height(4.dp))

        Button(
            onClick = {
                onNavigate(Screen.Jerome)
            },
            content = { Text("Website") })

        Spacer(modifier = Modifier.height(32.dp))

        Text("Terrence Robbins",
            textAlign = TextAlign.Center,
            fontWeight = FontWeight.Bold)

        Text("Leather carver",
            textAlign = TextAlign.Center)
        Spacer(modifier = Modifier.height(4.dp))

        Button(
            onClick = {
                onNavigate(Screen.Terrence)
            },
            content = { Text("Website") })

        Spacer(modifier = Modifier.weight(3f))
    }
}